export default __webpack_public_path__ + "static/media/p2.bb4b0717.png";